import type { $Fetch } from 'ofetch';
import type { MetodoAvaliativoGateway, ListMetodosParams } from '@/application/port/out/MetodoAvaliativoGateway';
import type { MetodoAvaliativo, UpsertMetodoAvaliativoCommand } from '@/domain/model/MetodoAvaliativo';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/metodos-avaliativos';

/** HTTP gateway do CRUD de Método Avaliativo. Authority BE: `assessment:read|manage`. */
export class HttpMetodoAvaliativoGateway implements MetodoAvaliativoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListMetodosParams): Promise<Page<MetodoAvaliativo>> {
    const res = await this.client<ApiResponse<Page<MetodoAvaliativo>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertMetodoAvaliativoCommand): Promise<MetodoAvaliativo> {
    const res = await this.client<ApiResponse<MetodoAvaliativo>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertMetodoAvaliativoCommand): Promise<MetodoAvaliativo> {
    const res = await this.client<ApiResponse<MetodoAvaliativo>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    // BE 204 No Content — sem envelope.
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
